import { Box, ButtonGhost, Flex } from '@npco/zeller-design-system'
import { useModalState } from 'design-system/Components/Modal/hooks/useModalState'
import { ModalBasic } from 'design-system/Components/Modal/ModalBasic/ModalBasic'

import { useLogout } from 'hooks/useLogout'
import { BasicModal } from 'components/BasicModal'
import { StyledButtonSpecial } from 'components/Buttons/ButtonSpecial'
import { component } from 'translations'

import { StyledContainer, StyledTextBlack } from './ModalOnboardingSave.styled'

const onPrimaryButtonClick = (closeModal: () => void, logout: () => void) => {
  closeModal()
  logout()
}

export const ModalOnboardingSave: React.FC<{ isMobile?: boolean }> = ({
  isMobile,
}) => {
  const { isModalOpen, openModal, closeModal } = useModalState()

  const { logout } = useLogout()
  return (
    <Box data-testid="modal-onboarding-save-wrapper" pb="24px" hidden>
      <Flex justifyContent="center">
        {isMobile ? (
          <ButtonGhost onClick={openModal}>
            {component.saveOnboardingModal.toggleButtonLabelMobile}
          </ButtonGhost>
        ) : (
          <StyledButtonSpecial onClick={openModal}>
            {component.saveOnboardingModal.toggleButtonLabel}
          </StyledButtonSpecial>
        )}
      </Flex>
      <ModalBasic isOpen={isModalOpen} onCancel={closeModal}>
        <BasicModal
          dataTestId="modal-onboarding-save"
          modalDescription={
            <StyledContainer>
              {component.saveOnboardingModal.description}
              <StyledTextBlack>
                {component.saveOnboardingModal.linkLabel}
              </StyledTextBlack>
            </StyledContainer>
          }
          modalTitle={component.saveOnboardingModal.title}
          primaryButtonLabel={component.saveOnboardingModal.primaryButtonLabel}
          onPrimaryButtonClick={() => onPrimaryButtonClick(closeModal, logout)}
          onSecondaryButtonClick={closeModal}
        />
      </ModalBasic>
    </Box>
  )
}
